var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-calendar overflow-hidden border" }, [
    _c("div", { staticClass: "row no-gutters" }, [
      _c(
        "div",
        { staticClass: "col-sm-12" },
        [
          _c(
            "b-card",
            [
              _c("b-card-title", { staticClass: "mb-1" }, [_vm._v("Legend")]),
              _c(
                "b-card-body",
                [
                  _c(
                    "b-badge",
                    { staticClass: "mr-1", attrs: { variant: "primary" } },
                    [_vm._v("Delivered")]
                  ),
                  _c(
                    "b-badge",
                    { staticClass: "mr-1", attrs: { variant: "warning" } },
                    [_vm._v("In Transit")]
                  ),
                  _c(
                    "b-badge",
                    { staticClass: "mr-1", attrs: { variant: "danger" } },
                    [_vm._v("Pending")]
                  ),
                  _c(
                    "b-badge",
                    { staticClass: "mr-1", attrs: { variant: "dark" } },
                    [_vm._v("Cancelled")]
                  ),
                  _c(
                    "b-badge",
                    { staticClass: "mr-1", attrs: { variant: "secondary" } },
                    [_vm._v("Returned")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "col position-relative" }, [
        _c("div", { staticClass: "card shadow-none border-0 mb-0 rounded-0" }, [
          _c(
            "div",
            { staticClass: "card-body pb-0" },
            [
              _c("full-calendar", {
                attrs: {
                  plugins: _vm.calendarPlugins,
                  events: _vm.fcEvents,
                  options: _vm.calendarOptions,
                },
              }),
            ],
            1
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }